import styled from 'styled-components';

const Container = styled.div.withConfig({
  componentId: 'triple-x_container',
  displayName: 'TripleX.Container',
})<{ $gap?: string; $align?: string }>`
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.$gap};
  align-items: ${(props) => props.$align};
`;

const Rest = styled.div.withConfig({
  componentId: 'triple-x_rest',
  displayName: 'TripleX.Rest',
})`
  flex-grow: 1;
  flex-shrink: 1;

  min-width: 0;
`;

const Side = styled.div.withConfig({
  componentId: 'triple-x_side',
  displayName: 'TripleX.Side',
})`
  flex-grow: 0;
  flex-shrink: 0;
`;

export const TripleX = {
  Container,
  Rest,
  Side,
};
